import { useState, useRef } from 'react'
import { ChevronUp, ChevronDown } from 'lucide-react'

const Collapsible = ({ label, children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const contentRef = useRef(null)

  return (
    <>
      <div className='relative'>
        <div className='absolute inset-0 flex items-center' aria-hidden='true'>
          <div className='w-full border-t border-border' />
        </div>

        <div className='relative flex'>
          <button
            onClick={() => setIsOpen(!isOpen)}
            type='button'
            className='inline-flex items-center gap-x-1.5 rounded-full bg-background px-3 py-1.5 text-sm font-semibold shadow-xs ring-1 ring-inset ring-border hover:bg-muted transition-colors duration-200'
          >
            {isOpen ? <ChevronDown className='-ml-1 -mr-0.5 h-5 w-5 text-muted-foreground' aria-hidden='true' /> : <ChevronUp className='-ml-1 -mr-0.5 h-5 w-5 text-muted-foreground' aria-hidden='true' />}
            {label}
          </button>
        </div>
      </div>

      <div
        ref={contentRef}
        className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'}`}
      >
        {children}
      </div>
    </>
  )
}

export default Collapsible
